module.exports = __webpack_public_path__ + "static/img/3.5ee38a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/08/3.png
// module id = 7A2Y
// module chunks = 2